import { FC } from 'react'
import { FormOutlined } from '@ant-design/icons'

import cn from './index.module.css'

interface IAddNoteCard {
  onClick: () => void
}

const AddNoteCard: FC<IAddNoteCard> = ({ onClick }) => {
  return (
    <div className={cn.wrapper} onClick={onClick}>
      <FormOutlined 
        className={cn.icon}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      />
      <div className={cn.title}>Добавить заметку</div>
    </div>
  )
}

export default AddNoteCard
